var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import firstFilterCondition from '../console-common/first-filter-condition.vue';
export default Vue.extend({
    name: 'fundLoanManageFilterCondition',
    components: {
        'custom-first-filter-condition': firstFilterCondition,
    },
    data: function () {
        var _this = this;
        return {
            firstFilterCondition: {},
            firstFilterConditionConfig: [
                {
                    type: 'search',
                    label: '资金方名称',
                    key: 'capitalCode',
                    options: [],
                    remoteMethod: function (val) {
                        _this['getTenantName'](val);
                    },
                    clearCallback: function () {
                        _this['getTenantName']();
                    },
                },
                {
                    type: 'radio',
                    label: '代扣协议',
                    key: 'signStatus',
                    radios: [
                        {
                            label: '',
                            text: '全部',
                        },
                        {
                            label: 'SIGNED',
                            text: '已签署',
                        },
                        {
                            label: 'NOT_SIGN',
                            text: '未签署',
                        },
                    ],
                    defaultValue: '',
                },
                {
                    type: 'select',
                    label: '订单状态',
                    key: 'status',
                    options: [
                        {
                            label: '正常',
                            value: 'NORMAL',
                        },
                        {
                            label: '逾期',
                            value: 'OVERDUE',
                        },
                        {
                            label: '已还清',
                            value: 'PAID_OFF',
                        },
                        {
                            label: '已终止',
                            value: 'TERMINAL',
                        },
                    ],
                    defaultValue: this.$route.params.status || '',
                    isRouteParam: true,
                },
            ],
        };
    },
    computed: __assign({}, mapState('common', {
        tenantCodeList: 'tenantCodeList',
    }), { filterCondition: function () {
            return Object.assign({}, this.firstFilterCondition);
        } }),
    created: function () {
        this.getTenantName();
    },
    watch: {
        tenantCodeList: function (val) {
            this.firstFilterConditionConfig[0].options = val;
        },
        firstFilterCondition: {
            deep: true,
            handler: function (val) {
                this.$emit('get-param', val);
            },
        },
    },
    methods: {
        getTenantName: function (val) {
            if (val === void 0) { val = ''; }
            this.$store.dispatch('common/GET_TENANT_CODE', {
                tenantName: val,
                tenantType: 'CAPITAL',
            });
        },
        getFirstFilterCondition: function (param) {
            this.firstFilterCondition = param;
        },
    },
});
